import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Alert, Row, Table, Button, Pagination, PaginationItem, PaginationLink, Col } from 'reactstrap'
import { Link } from 'react-router-dom'
import PageContainer from '../../Shared/LayoutComponents/PageContainer'
import PageHeading from '../../Shared/LayoutComponents/PageHeading'
import LoadingSpinner from '../../Shared/LoadingSpinner'
import useFetchingReconDetails from './useFetchingReconDetails'
import ReconProductItem from './ReconProductItem'
import Moment from 'react-moment'
import { AzureAD } from 'react-aad-msal'
import store from '../../../store/configureStore'
import { authProvider } from '../../../services/authProvider'

const ReconDetails = ({ selectedCompany, reconSelected, reconSelectedDetails, loading }) => {
  let pageSize = 10
  const [currentPage, setCurrentPage] = useState(0)
  let pagesCount = Math.ceil(
    reconSelectedDetails &&
      reconSelectedDetails.reconciliationProducts &&
      reconSelectedDetails.reconciliationProducts.length / pageSize
  )
  useFetchingReconDetails(reconSelected)

  if (loading) {
    return <LoadingSpinner />
  } else {
    return (
      <AzureAD provider={authProvider} reduxStore={store}>
        {({ login, logout, authenticationState, accountInfo }) => {
          let isAdmin = false
          let isSales = false
          if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
            if (accountInfo.account.idToken.roles.includes('Admin')) {
              isAdmin = true
              isSales = true
            } else if (accountInfo.account.idToken.roles.includes('Sales')) {
              isSales = true
            }
          }
          return (
            <PageContainer>
              <Row>
                <PageHeading small={true} fullWidth={true}>
                  {selectedCompany.name} Products for{' '}
                  <Moment format="MMMM YYYY">{reconSelectedDetails && reconSelectedDetails.reconciliationMonth}</Moment>
                  {(isAdmin || isSales) && (
                    <Link to="/UserUploadTemplate.csv" target="_blank" download>
                      <Button style={{ float: 'right' }} size="sm" outline color="primary">
                        Download Template
                      </Button>
                    </Link>
                  )}
                </PageHeading>
              </Row>
              {(reconSelectedDetails != null && reconSelectedDetails.agreement != null) ? (
                <Row>
                  <Col sm={4}>
                    <Alert color="primary">
                      <h4 className="alert-heading">Syncing Agreement Details</h4>
                      <Row>
                        <Col sm={4}><b>Name</b></Col>
                        <Col sm={8}>{reconSelectedDetails.agreement.name}</Col>
                      </Row>
                      <Row>
                        <Col sm={4}><b>Type</b></Col>
                        <Col sm={8}>{reconSelectedDetails.agreement.type.name}</Col>
                      </Row>
                      <Row>
                        <Col sm={4}><b>Status</b></Col>
                        <Col sm={8}>{reconSelectedDetails.agreement.agreementStatus}</Col>
                      </Row>
                      <Row>
                        <Col sm={4}><b>Date Start</b></Col>
                        <Col sm={8}><Moment format="DD/MM/YYYY">{reconSelectedDetails.agreement.startDate}</Moment></Col>
                      </Row>
                    </Alert>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col sm={4}>
                    <Alert color="danger">
                      <h4 className="alert-heading">No Agreement Found</h4>
                      <p className="mb-0">
                        Speak with SD before syncing these additions.
                      </p>
                    </Alert>
                  </Col>
                </Row>
              )}
              <div>
                <Pagination aria-label="Page navigation" style={{ float: 'right' }}>
                  <PaginationItem disabled={currentPage <= 0}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage - 1)} previous href="#" />
                  </PaginationItem>
                  {[...Array(pagesCount)].map((page, i) => (
                    <PaginationItem active={i === currentPage} key={i}>
                      <PaginationLink onClick={() => setCurrentPage(i)} href="#">
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage + 1)} next href="#" />
                  </PaginationItem>
                </Pagination>
                <Link to={`/reconciliation/${reconSelectedDetails && reconSelectedDetails.companyId}/List`}>
                  <Button style={{ color: 'rgb(78, 85, 91)' }} color="link">
                    Back
                  </Button>
                </Link>
              </div>
              <Table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Users Imported</th>
                    <th>Upload User CSV</th>
                  </tr>
                </thead>
                {reconSelectedDetails &&
                reconSelectedDetails.reconciliationProducts &&
                reconSelectedDetails.reconciliationProducts.length > 0 ? (
                  <tbody>
                    {reconSelectedDetails.reconciliationProducts
                      .slice(currentPage * pageSize, currentPage * pageSize + pageSize)
                      .map((product, index) => (
                        <ReconProductItem
                          isAdmin={isAdmin}
                          isSales={isSales}
                          index={index}
                          key={index}
                          product={product}
                        />
                      ))}
                  </tbody>
                ) : (
                  <tbody>
                    <td colSpan="6" style={{ textAlign: 'center', fontSize: '1.25rem' }}>
                      No Products Found
                    </td>
                  </tbody>
                )}
              </Table>
            </PageContainer>
          )
        }}
      </AzureAD>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.recon.loading,
  selectedCompany: state.recon.selectedCompany,
  reconSelected: state.recon.reconSelected,
  reconSelectedDetails: state.recon.reconSelectedDetails,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ReconDetails)
